import React from "react";
import { Layout, Avatar, Dropdown, Menu, Select, message } from "antd";
import FontIcon from "../components/YhIcon";
import { useHistory } from "react-router-dom";
import useGlobalModel from "../model/globalModel";
import useNavModel from "../model/navModel";
import Logo from "@/assets/images/header-logo.png"
import LogoYh from "@/assets/images/logo-yh.png"
import { ISelectOption } from "@/components/YhFormBox/Types";
import { shopService } from "@/views/organization/shop/shopService";
import { isArray } from "util";
import { UserOutlined } from "@ant-design/icons";
import { loginServiceAuth2 } from "@/views/login/LoginServiceAuth2";
import { closeWebPage } from "@/utils/utils";
import { CLIENT_APP_CODE, isProdEnv } from "@/utils/constants";

const { Header } = Layout;

function ScmHeader() {
    const history = useHistory();
    const { user, shopDs, setUser, requestCacheAll, setBeShopDs } = useGlobalModel();
    const { initNav } = useNavModel(() => []);
    const headerLogo = isProdEnv ? LogoYh : Logo;

    //退出登录
    const onLogout = () => {
        if (user.loginType === "account") {
            setUser({ ...user, shopId: "", shopName: "", shopCode: "", token: "" });
            initNav();
            history.push("/login");
            loginServiceAuth2.Logout();
            loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? "");
        } else {
            closeWebPage();
        }

    };

    const onClearCache = () => {
        initNav()
    }

    // 菜单项
    const HeaderMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={onClearCache}>关闭所有标签</span>
                </Menu.Item>
                {/* <Menu.Divider /> */}
            </Menu>
        )
    }

    //门店选择
    const onShopChang = async (value: string, options: ISelectOption) => {
        if (options && options.value) {
            onClearCache();  //清楚页签
            setUser({ ...user, shopId: value, shopName: options.label, shopCode: options.code as string });  //用户信息门店信息改变
            requestCacheAll(value);  //重新刷新门店id的缓存
            message.success("切换门店成功");

            //切换门店， 设置对应门店下面的实体 缓存
            let { retData } = await shopService.one({
                sourceApp: "gtm",
                branch: "main",
                code: options.code
            });
            if (retData) {
                let { details } = retData;
                if (isArray(details)) {
                    setBeShopDs(details?.map(item => ({
                        id: item.id,
                        label: item.bentityName ?? "",
                        value: item.bentityCode ?? ""
                    })) ?? []);
                } else {
                    setBeShopDs([]);
                }
            }
        }
    }

    return (
        <Header className="layout-section-header">
            {/* 左侧按钮 */}
            <div className="layout-sider-logo">
                <img className="layout-sider-logo-img" src={headerLogo} alt="管理系统Logo" />
                {/* <span className="one-line">外贸管理系统</span> */}
            </div>

            {/* <span style={{ fontSize: "22px", fontWeight: "bold", color: "#2db7f5" }}>{user.shopName}</span> */}
            {/* 右侧内容 */}
            <div className="header-right" style={{ paddingRight: "15px" }}>
                {/* <Select
                    defaultValue={user.shopId}
                    style={{ width: "250px" }}
                    className="header-right-item"
                    onChange={(value, options) => onShopChang(value, options as ISelectOption)}
                    options={shopDs}
                /> */}
                {/* 设置 */}
                <Dropdown overlay={HeaderMenu} placement="bottomCenter" trigger={['click']}>
                    <Avatar className="header-right-item config-icon" icon={<FontIcon type="icon-shezhi" />} />
                </Dropdown>

                {/* 登录用户信息 */}
                <span onClick={e => e.preventDefault()} className="header-right-item user-info white-space">
                    <Avatar
                        size="default"
                        icon={<UserOutlined />}
                        className="user-icon"
                    />
                    <span className="account">{user.userName ?? "未获取到"}</span>
                </span>

                {/* 退出登录 */}
                <FontIcon type="icon-tuichu" className="header-right-item logout-icon" onClick={() => onLogout()} />
            </div>
        </Header>
    )
}

export default ScmHeader;
